export const parseJwt = (token) => {
  try {
    // Get Token Header
    const base64HeaderUrl = token.split('.')[0];
    const base64Header = base64HeaderUrl.replace('-', '+').replace('_', '/');
    const headerData = JSON.parse(window.atob(base64Header));

    // Get Token payload and date's
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace('-', '+').replace('_', '/');
    const dataJWT = JSON.parse(window.atob(base64));
    dataJWT.header = headerData;

    return dataJWT;
  } catch (err) {
    return false;
  }
}

export const getRefreshToken = (refreshTokenName) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${refreshTokenName}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

export const setRefreshSetToken = (name, value, expDays) => {
  let date = new Date();
    date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + "; " + expires + "; path=/";
}

export const checkToken = (token) => parseJwt(token);